package ai.jessie.shared.documents

import kotlinx.serialization.Serializable

// UC-017 / FR-017. Validate and confirm both take a multipart body with exactly one file part
// (B3, B8); the server repeats every check at confirmation. IDs are document public IDs.

// Step 5: the validated file, nothing stored. mediaType is the detected canonical type (B2).
@Serializable
data class DocumentValidationResponse(
    val fileName: String,
    val mediaType: String,
    val sizeBytes: Long,
)

// B6: inbox list item and metadata-only detail; uploadedAt is the authoritative server time.
@Serializable
data class DocumentResponse(
    val documentId: String,
    val fileName: String,
    val mediaType: String,
    val sizeBytes: Long,
    val uploadedAt: String,
)

// Codes: FILE_EMPTY / FILE_TOO_LARGE (A1), CONTENT_UNSUPPORTED (A2), DUPLICATE_DOCUMENT with
// existingDocumentId (A3), UPLOAD_NOT_COMPLETED (A6) and MALWARE_DETECTED (A7). A4 uses the
// tenant codes PERMISSION_DENIED and NOT_FOUND. A hidden duplicate (A8) is never reported.
// UC-020: INVALID_DETAILS, FIELD_NOT_EDITABLE, INVALID_REASON (problems), DOCUMENT_READ_ONLY,
// TRANSITION_NOT_PERMITTED (A2, with document), CHOICE_UNAVAILABLE (A3, problems),
// ARCHIVE_INCOMPLETE (A5, problems), RELEVANCE_LOCKED (BR-130), INVALID_PAYMENT_DATE (A6,
// problems), LINKED_INVOICE_NOT_SENT (A7), LINKED_PAYMENT_IMMUTABLE (A8), PAYMENT_MISSING,
// REMOVAL_NOT_ELIGIBLE (A12), DOCUMENT_CHANGED (A14, with document) and NOT_COMPLETED (A15).
@Serializable
data class DocumentProblemResponse(
    val code: String,
    val existingDocumentId: String? = null,
    val problems: List<DocumentFieldProblem> = emptyList(),
    val document: DocumentDetailResponse? = null,
)
